<template>
  <ten-list
    class="ten-list--rich"
    :title="title"
    :data="data"
    :columns="columns"
    :direction="direction"
    :infinite-scroll="infiniteScroll"
  >
    <template v-slot:item="{ item }">
      <div
        class="ten-list__item__rich"
        @click="_click(item)"
      >
        <div
          class="ten-list__item__rich-thumb"
          v-if="item.image"
        >
          <ten-image
            :src="item.image"
            fit="cover"
          />
        </div>
        <div class="ten-list__item__rich-main">
          <div class="ten-list__item__rich-title">
            {{ item.title }}
          </div>
          <div class="ten-list__item__rich-content">
            {{ item.content }}
          </div>
        </div>
        <div class="ten-list__item__rich-more">
          <ten-icon
            icon="edit"
            @click.stop="_edit(item)"
          />
          <ten-icon
            icon="delete"
            @click.stop="_delete(item)"
          />
        </div>
      </div>
    </template>
  </ten-list>
</template>

<script>
import TenList from './list.vue';
import TenImage from '../image/image.vue';
import TenIcon from '../icon/icon.vue';

export default {
  components: {
    TenList,
    TenImage,
    TenIcon,
  },
  props: {
    /**
     * 列表的标题，不传不展示 header 部分
     */
    title: {
      type: String,
      default: '',
    },

    /**
     * 列表分多少栏
     */
    columns: {
      type: Number,
      default: 1,
    },

    /**
     * 分栏的时候，元素朝哪个方向排列。
     * row 从左往右排列
     * column 从上往下排列
     */
    direction: {
      type: String,
      default: 'row',
    },

    /**
     * 数据
     */
    data: Array,

    /**
     * 无限下拉加载
     */
    infiniteScroll: Function,
  },
  methods: {
    _edit(item) {
      /**
       * 点击编辑按钮触发
       * @param {object} item 被点击的item
       */
      this.$emit('item-edit', item);
    },
    _delete(item) {
      /**
       * 点击删除按钮触发
       * @param {object} item 被点击的item
       */
      this.$emit('item-delete', item);
    },
    _click(item) {
      /**
       * 点击整个item触发
       * @param {object} item 被点击的item
       */
      this.$emit('item-click', item);
    },
  },
};
</script>
